import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/machine/products2/partners-products/filter'; // Importing Filter component
import Table from 'views/machine/products2/partners-products/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersProductsView class extends JetView to create a specific view for partner products.
 */
export default class PartnersProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Retrieves the current theme from app configuration
        const left = {
            rows: [Filter, Table], // Defines the layout with Filter and Table components
        };
        webix.ui.fullScreen(); // Sets the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Specifies that the main view is a form
            scroll: 'y', // Enables vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Type of the column layout
                    cols: [left], // Columns layout containing the left section
                },
            ],
        };
    }

    /**
     * Initializes the view. Currently empty but can be used for setup tasks.
     */
    init() {}
}

// FILE DOCUMENTED
